import { gql } from '@apollo/client';
import COMPONENT_COLORS_AND_SIZES from './COMPONENT_COLORS_AND_SIZES';
const MODEL_FRAGMENT = gql `
  ${COMPONENT_COLORS_AND_SIZES}
  fragment ModelFragment on ModelSpecificationNode {
    id
    estimatedCostCalculationBlocked
    specificationTeamMembersNode {
      id
      adminName
      patternerName
      designerName
      productionName
    }
    confirmationProblems {
      id
      problemType
      blocksEstimatedCostCalculation
      blocksSpecificationConfirmation
      components {
        id
        nodeId
        nodeName
      }
      componentVariants {
        id
        nodeId
        nodeName
      }
    }
    estimatedCostCalculationProblems {
      id
      problemType
      blocksEstimatedCostCalculation
      blocksSpecificationConfirmation
      components {
        id
        nodeId
        nodeName
      }
      componentVariants {
        id
        nodeId
        nodeName
      }
    }
    fancyName
    itemCode
    description
    productionTimeMinutes
    files {
      edges {
        node {
          id
          file
        }
      }
    }
    sharedmodelspecificationSet {
      edges {
        node {
          id
          status
          sharedWith {
            id
            username
            email
          }
        }
      }
    }
    author {
      id
      username
    }
    folder {
      id
      name
      path {
        id
        name
      }
    }
    sizeStandard {
      id
      name
    }
    image
    sizes {
      edges {
        node {
          id
          isActive
          sizeName {
            id
            name
          }
        }
      }
    }
    state
    elements {
      edges {
        node {
          id
          name
          elementSizes {
            edges {
              node {
                id
                dimension
                modelSpecificationSize {
                  id
                  sizeName {
                    id
                    name
                  }
                }
              }
            }
          }
        }
      }
    }
    colors {
      edges {
        node {
          id
          name
          isActive
        }
      }
    }
    tags {
      edges {
        node {
          id
          tag {
            id
            name
          }
        }
      }
    }
    status {
      id
      namePL
      nameEN
      color
    }
    projections {
      edges {
        node {
          id
          name
          number
          picture
          points {
            edges {
              node {
                id
                x
                y
                noteX
                noteY
                note
                photoNumber
                isVisible
                typeCode
                photo
                component {
                  id
                  name
                  productCategory {
                    id
                    type
                    typeLabelPL
                    typeLabelEN
                    typeIcon
                  }
                }
              }
            }
          }
        }
      }
    }
    persons {
      edges {
        node {
          id
          status
          position {
            name
          }
          isAdmin
          user {
            id
            username
            email
            avatar
          }
        }
      }
    }
    season {
      id
      name
    }
    category {
      id
      name
    }
    brand {
      id
      name
    }
    variants {
      edges {
        node {
          id
          isActive
          quantity
          color {
            id
            name
          }
          size {
            id
          }
        }
      }
    }
    components {
      edges {
        node {
          id
          photo
          name
          isConsumptionSet
          piecesPerMarker
          consumptionVariedOnSize
          hasOneVariantColorForAllSpecificationColors
          hasOneVariantSizeForAllSpecificationSizes
          variantColorForAllSpecificationColors
          variantSizeForAllSpecificationSizes
          ...ComponentColorsAndSizesFragment
          productSnapshot {
            id
            name
            productDescription
            supplierFullName
            supplierShortName
            width
            componentSize
            composition
            zipperType
            grammage
            producerCode
            underSliderType
            upperSliderType
            yardage
            image
            variantSnapshots {
              edges {
                node {
                  id
                  color
                  size
                }
              }
            }
            product {
              id
              name
              status
              pictures {
                edges {
                  node {
                    id
                    image
                  }
                }
              }
              zipperType {
                id
                name
                upperSlider
                underSlider
              }
              grammage {
                id
                name
              }
              componentSize {
                id
                name
              }
              width {
                id
                name
              }
              composition {
                id
                name
              }
              producerCode {
                id
                name
              }
              underSliderType {
                id
                name
              }
              upperSliderType {
                id
                name
              }
              yardage {
                id
                name
              }
            }
          }
          consumptions {
            edges {
              node {
                id
                consumption
                modelSpecificationSize {
                  id
                  sizeName {
                    id
                    name
                  }
                }
              }
            }
          }
          productCategory {
            id
            type
            typeLabelPL
            typeLabelEN
            typeIcon
            hasName
            hasComposition
            hasComponentSize
            hasSupplier
            hasProductDescription
            hasWidth
            hasPiecesPerMarker
            hasZipperType
            variantHasColor
            variantHasChainColor
            variantHasTapeColor
            variantHasSliderColor
            variantHasSize
            hasGrammage
            hasUpperSliderType
            hasUnderSliderType
            hasProducerCode
            hasYardage
            colorAutoCalculationMethod
            consumptionType {
              id
              name
              labelPL
              labelEN
              integerValues
            }
          }
        }
      }
    }
  }
`;
export default MODEL_FRAGMENT;
